import React from "react"
import {useParams, Link, useLocation, useNavigate} from "react-router-dom"
import {useQuery} from "react-query"
import classNames from "classnames"
import useAuth from "auth/useAuth"
import moment from "moment"
import Tab from 'react-bootstrap/Tab'
import Tabs from 'react-bootstrap/Tabs'
import Notes from "components/rescuer/notes/Notes"
import PhoneButtons from "components/rescuer/PhoneButtons"
import RescuerTags from "./RescuerTags"
import RescuerSeasons from "./RescuerSeasons"
import RescuerLevels from "./RescuerLevels"
import RescuerRescuesTab from "./RescuerRescuesTab"
import RescuerShiftsTab from "./RescuerShiftsTab"
import RescuerUploadsTab from "./RescuerUploadsTab"
import {getNicknames} from "utils/utils"
import {formatBirthdate} from "utils/date_utils"
import "./RescuerProfilePage.css"


/** https://javascript.plainenglish.io/how-to-pass-data-between-pages-in-react-router-dom-v6-e2f95afb7cdf */
export default function RescuerProfilePage(props) {

    const {username} = useParams()
    const location = useLocation()
    const navigate = useNavigate()
    const {auth, API} = useAuth()
    const {data} = useQuery(["rescuer", username], () => auth(API.rescuersIdGet, {id: username}).then(response => response.data))

    const hash = location.hash.replace('#', '')
    const defaultTab = 'status'
    const activeTab = hash || defaultTab

    const handleTabSelect = (key) => {
        if (key === defaultTab) {
            navigate(`/rescuer/${username}`, {replace: true})
        } else {
            navigate(`/rescuer/${username}#${key}`, {replace: true})
        }
    }

    if (!data)
        return <div id="spinner" className="center"/>
    
    const rescuer = data.rescuer
    const permissions = data.permissions
    const nicknames = getNicknames(rescuer).join(', ')

    
    return <div id="profile" className="container-fluid">
    
        <section id="profile-main" className="shadow">
        
            <div id="profile-picture" className={classNames({deceased: rescuer.deceased})}>
                <img alt="" src={rescuer.profile || ''}/>
            </div>
            
            <RescuerTags username={username}/>
            
            <div id="profile-info">                
                <div id="first-row">
                    <div>{rescuer.gss_id}</div>
                    {permissions.edit_any && <div id="profile-buttons"><Link className="btn btn-light btn-sm" to={`/rescuer/${username}/edit`}><i className="fa-solid fa-pen"/></Link></div>}
                </div>
                <div id="profile-name">{rescuer.given_name} {rescuer.family_name}</div>
                <div>{nicknames}</div>
                <hr/>
                <div><a href={`mailto:${rescuer.email || ''}`}>{rescuer.email || ''}</a></div>
                <div>               
                    {rescuer.phone_number && <span>{rescuer.phone_number || ''}
                        <span id="phone-buttons">
                            <PhoneButtons phone_number={rescuer.phone_number} sms={true}/>
                        </span>
                    </span>}
                </div>
                
                {(rescuer.address || rescuer.city) && <div>
                    {rescuer.address || ''}
                    {(rescuer.address && rescuer.city) && <>, </>}
                    {rescuer.city || ''}
                </div>}
                <div>Stanica {rescuer.station || <>&nbsp;&ndash;</>}</div>
                {(rescuer.birthdate || rescuer.deceased) && <div>
                    {rescuer.birthdate && formatBirthdate(rescuer.birthdate, moment)}
                    {rescuer.deceased && <>
                        {rescuer.birthdate ? <>&nbsp;&ndash; </> : '† '}
                        {typeof rescuer.deceased === 'string' && formatBirthdate(rescuer.deceased, moment)}
                    </>}
                </div>}
                {rescuer.admission_year && <div>Godina završetka kursa: {rescuer.admission_year}.</div>}
                <div>Ocena skijanja: {rescuer.ski || <>&nbsp;&ndash;</>}</div>
                <div>PSS broj: {rescuer.pss_id || <>&nbsp;&ndash;</>}</div>
            </div>  
            
        </section>

        <Tabs activeKey={activeTab} onSelect={handleTabSelect} className="mt-3">
            <Tab eventKey="status" title="Status" mountOnEnter unmountOnExit>
                <div id="status-tab">
                    <RescuerSeasons rescuer={rescuer}/>
                    <div className="spacer"/>
                    <RescuerLevels username={username}/>
                </div>
            </Tab>
            <Tab eventKey="notes" title="Beleške" mountOnEnter unmountOnExit>
                <Notes username={username} permissions={permissions}/>
            </Tab>
            {(permissions.self || permissions.admin) && <Tab eventKey="rescues" title="Povredne liste" mountOnEnter unmountOnExit>
                <RescuerRescuesTab username={username}/>
            </Tab>}
            <Tab eventKey="shifts" title="Smene" mountOnEnter unmountOnExit>
                <RescuerShiftsTab username={username}/>
            </Tab>
            {(permissions.self || permissions.admin) && <Tab eventKey="uploads" title="Profilne slike" mountOnEnter unmountOnExit>
                <RescuerUploadsTab username={username}/>
            </Tab>}
        </Tabs>
    </div>

}